import { defineAction } from '~/prix'
import userListAction from './userList.action.json' with { type: 'json' }
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const optionalNonNegativeInteger = z.preprocess(value => {
  if (value === undefined || value === null || value === '') {
    return undefined
  }

  return typeof value === 'number' ? value : Number(value)
}, z.number().int().nonnegative().optional())

const userListDefinition = defineAction({
  ...userListAction,

  input: z
    .object({
      search: z.string().trim().optional().describe('Buscar usuários por nome ou email'),
      filter: z.any().nullish(),
      includeDeleted: z.boolean().nullish(),
      limit: optionalNonNegativeInteger,
      offset: optionalNonNegativeInteger,
      orderBy: enumerated({
        name: 'Nome',
        email: 'Email',
        role: 'Função',
        createdAt: 'Data de criação',
        updatedAt: 'Data de atualização',
      }).nullish(),
      order: enumerated({
        ascending: 'Ascendente',
        descending: 'Descendente',
      }).nullish(),
    })
    .passthrough(),
  output: z.object({
    items: z.array(
      z.object({
        id: z.string(),
        role: z.string(),
        name: z.string(),
        email: z.string(),
        cpf: z.string().nullish(),
        isEmailVerified: z.boolean().nullish(),
        cns: z.string().nullish(),
        clientId: z.number(),
        createdAt: z.date(),
        updatedAt: z.date(),
      }),
    ),
  }),
})

export default userListDefinition
